import Navbar from './Components/Navbar/Navbar';
import Hero from './Components/Hero/Hero';
import styles from './App.module.css';
import { useEffect, useState } from 'react';
import { fetchTopAlbums, fetchNewAlbums, fetchSongs } from './api/api';
import Section from './Components/Section/Section';
import FilterSection from './Components/FilterSection/FilterSection';
import Footer from './Components/Footer/Footer';

const App = () => {
  const [topAlbumSongs, setTopAlbumSongs] = useState([])
  const [newAlbumSongs, setNewAlbumSongs] = useState([])
  const [allSongs, setAllSongs] = useState([])
  const [filteredDataValues, setFilteredDataValues] = useState([])
  const [toggle, setToggle] = useState(false)
  const [value, setValue] = useState(0);

  const generateSongsData = (value) => {
    let songData = [...allSongs];

    if (value === 0) {
      setFilteredDataValues(songData)
      return;
    }

    let key;
    if (value === 1) key = 'rock';
    else if (value === 2) key = 'pop';
    else if (value === 3) key = 'jazz';
    else if (value === 4) key = 'blues';

    const data = songData.filter((item) => {
      return item.genre.key === key
    })
    setFilteredDataValues(data)
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
    generateSongsData(newValue)
  }

  const handleToggle = () => {
    setToggle(!toggle)
  }

  const filteredData = (val) => {
    generateSongsData(val)
  }

  const generateTopAlbumSongs = async () => {
    try {
      const topAlbumSongsData = await fetchTopAlbums()
      setTopAlbumSongs(topAlbumSongsData)
    }
    catch (error) {
      console.log(error)
    }
  }

  const generateNewAlbumSongs = async () => {
    try {
      const newAlbumSongsData = await fetchNewAlbums()
      setNewAlbumSongs(newAlbumSongsData);
    }
    catch (error) {
      console.log(error)
    }
  }

  const generateFilterSongs = async () => {
    try {
      const dataSongs = await fetchSongs()
      setAllSongs(dataSongs);
      setFilteredDataValues(dataSongs);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    generateTopAlbumSongs();
    generateNewAlbumSongs();
    generateFilterSongs();
  }, [])
  
  return (
    <div className={styles.mainWrapper}>
      <Navbar />
      <div className={styles.contentWrapper}>
        <Hero />
        <div className={styles.sectionWrapper}>
          <Section 
          type='album' 
          title='Top Albums' 
          data={topAlbumSongs} 
          handleToggle={handleToggle}
          />
          <Section 
          type='album' 
          title='New Albums' 
          data={newAlbumSongs} 
          handleToggle={handleToggle}
          />
          <FilterSection 
          data={allSongs} 
          type='songFilter' 
          title='Songs' 
          filteredData={filteredData} 
          filteredDataValues={filteredDataValues} 
          value={value} 
          handleChange={handleChange} 
          handleToggle={handleToggle}
          />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default App